<template>
  <v-footer
    id="dashboard-core-footer"
    style="background: #afb7bf4a;"
    fixed
  >
    <v-container>
      <v-row
        align="center"
        no-gutters
      >

        <v-spacer class="hidden-sm-and-down" />

        <v-col
          cols="12"
          md="auto"
        >
          <div class="body-1 font-weight-light pt-6 pt-md-0 text-center">
            &copy; 2024, made with
            <v-icon size="18">
              mdi-heart
            </v-icon>
            by <a href="https://www.e-incube.com">INCUBE FZCO</a> for a better web.
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
  export default {
    name: 'DashboardCoreFooter',


  }
</script>

<style lang="sass">
  #dashboard-core-footer
    a
      font-size: .825rem
      font-weight: 500
      margin-inline-end : 10px
      text-decoration: none
      text-transform: uppercase
</style>
